import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { paginationNumbers } from '../../../common/pagination'
import PaginationItem from './PaginationItem'

const Pagination = ({ itemCount, currentPageNumber, link, postsLimit }) => {
  const uri = useRouter().asPath
  const mainPath = uri.split('/')[1]
  const path = link ? `${mainPath}/${link}` : mainPath
  const current = Number(currentPageNumber)
  const pageCount = Math.ceil(itemCount / postsLimit) || 1
  const pagination = paginationNumbers(current, pageCount)

  if (!itemCount || (current === 1 && itemCount < 10)) {
    return null
  }

  return (
    <div className="mx-0 flex justify-between py-12 text-xxs sm:text-sm">
      {current > 1 ? (
        <PaginationItem
          label="< Previous"
          path={current - 1 > 1 ? `/${path}/page/${current - 1}` : `/${path}`}
        />
      ) : (
        <div> </div>
      )}
      <div className="flex">
        {pagination.map((label) => (
          <PaginationItem
            label={label}
            key={label}
            path={label === 1 ? `/${path}/` : `/${path}/page/${label}`}
            current={current}
          />
        ))}
      </div>
      {current < pageCount ? (
        <PaginationItem label="Next >" path={`/${path}/page/${current + 1}`} />
      ) : (
        <div> </div>
      )}
    </div>
  )
}

Pagination.propTypes = {
  itemCount: PropTypes.number.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  link: PropTypes.string,
  postsLimit: PropTypes.number,
}

Pagination.defaultProps = {
  link: '',
  postsLimit: 10,
}

export default Pagination
